import { render, staticRenderFns } from "./ConsistensiesManager.vue?vue&type=template&id=66edf953&"
import script from "./ConsistensiesManager.vue?vue&type=script&lang=ts&"
export * from "./ConsistensiesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports